const TOKEN = 'user_token'

export const storeToken = token => localStorage.setItem(TOKEN, token)

export const loadToken = () => localStorage.getItem(TOKEN)
